module.exports = __webpack_public_path__ + "img/area-1.ee319176.png";